import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Column, Row } from '../layout';
import Theme from '../../styles/theme';
export const TabbedComponentContainer = ({ tabLinks, 'data-testid': dataTestId, children, overflowY = 'auto', tabsPaddingBottom = '1.5rem', containerMarginX = 4, }) => {
    const [showShadow, setShowShadow] = useState(false);
    const handleScroll = (event) => {
        const notScrolled = event.currentTarget.scrollTop === 0;
        if (!notScrolled && !showShadow) {
            setShowShadow(true);
        }
        else if (notScrolled && showShadow) {
            setShowShadow(false);
        }
        else {
            return;
        }
    };
    return (_jsxs(Column, { flexGrow: 1, minHeight: "1px", "data-testid": dataTestId, children: [_jsx(Row, { style: {
                    transition: 'box-shadow 100ms ease-out',
                    backgroundColor: Theme.colors.white,
                    paddingBottom: tabsPaddingBottom,
                }, flexShrink: 0, pb: 4, boxShadow: showShadow ? ' 0px 5px 5px -5px rgba(0,0,0,0.3);' : undefined, zIndex: 1, width: '100%', children: tabLinks.map((tab) => tab.link()) }), _jsx(Column, { position: "relative", overflowY: overflowY, overflowX: "hidden", "data-testid": "tabbed-component-container", onScroll: handleScroll, mx: containerMarginX, children: children })] }));
};
//# sourceMappingURL=tabbed_component_container.js.map